/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cv_Check_Login_RequiredInputs */

const en_cv_check_login_required = /** @type {(inputs: Cv_Check_Login_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please log in to use the CV Check.`)
};

const de_cv_check_login_required = /** @type {(inputs: Cv_Check_Login_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte melde dich an, um den Lebenslauf-Check zu nutzen.`)
};

/**
* | output |
* | --- |
* | "Please log in to use the CV Check." |
*
* @param {Cv_Check_Login_RequiredInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cv_check_login_required = /** @type {((inputs?: Cv_Check_Login_RequiredInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Check_Login_RequiredInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cv_check_login_required(inputs)
	return en_cv_check_login_required(inputs)
});